/**
 * src/components/agent/InterviewModePicker.jsx -- TICKET-1484. The chat's entry to the
 * in-app interviewer: three chips, Bug / Idea / Help. One tap starts that interview.
 *
 * Mobile-first (375px): a wrapping flex row, each chip flex 1 with minWidth 0 so a long
 * Spanish label wraps to a second row instead of overflowing. Tokens only, >= 44px.
 */
import { Bug, HelpCircle, Lightbulb } from 'lucide-react';
import { useT } from '../../lib/i18n/I18nContext';
import { bugText } from '../../lib/hooks/useBugReportChat';

const MODES = [
  { kind: 'bug', Icon: Bug, label: 'modeBug' },
  { kind: 'idea', Icon: Lightbulb, label: 'modeIdea' },
  { kind: 'help', Icon: HelpCircle, label: 'modeHelp' },
];

const chip = {
  flex: '1 1 0', minWidth: 0, minHeight: 44, padding: '8px 12px', border: 'none', borderRadius: 10,
  display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6,
  background: 'var(--glass)', color: 'var(--t1)', outline: '1px solid var(--border)',
  fontSize: 'var(--fs-13)', fontWeight: 600, cursor: 'pointer',
};
const chipOn = { ...chip, background: 'var(--accent)', color: 'var(--on-accent)', outline: 'none' };

export default function InterviewModePicker({ onSelect, value = null }) {
  const { t, locale } = useT();
  const lang = locale === 'en' ? 'en' : 'es';
  return (
    <div role="group" data-testid="interview-mode-picker" aria-label={bugText(t, lang, 'pickerLabel')} style={{ display: 'flex', flexWrap: 'wrap', gap: 8, minWidth: 0, flex: 1 }}>
      {MODES.map(({ kind, Icon, label }) => (
        <button
          key={kind}
          type="button"
          data-testid={`interview-mode-${kind}`}
          aria-pressed={value === kind}
          onClick={() => onSelect?.(kind)}
          style={value === kind ? chipOn : chip}
        >
          <Icon size={16} /> {bugText(t, lang, label)}
        </button>
      ))}
    </div>
  );
}
